import React, {useState} from 'react';
import {Grid} from "@mui/material";
import '../login/Login.css'
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";
import {useEffect} from "react";
import {css} from "@emotion/css";
import InputSubmitCodeRaiko from "../../raikoComponents/raikoInputs/InputSubmitCodeRaiko";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import CopyRightLinkRaiko from "../../raikoComponents/copyRightLinkRaiko/CopyRightLinkRaiko";
import AppBrand from "../../component/appBrand/AppBrand";
import DarkModeToggle from "../../component/darkModeToggle/DarkModeToggle";
import {readToken} from "../../service/authService/AuthService";
import {LoginService} from "../login/LoginService";
import {setUserRefreshToken} from "../../service/localStorage/LocalStorageService";
import {actionTypes, setLoginStateDispatch} from "../../context/reducer";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";


const ConfirmPhoneNumber = () => {

    const service = new LoginService()

    const snackbarState = useSnackbarDispatcher()
    const loadingState = useLoadingDispatcher()

    const snackbar = new SnackbarHelper(snackbarState)
    const loading = new LoadingHelper(loadingState)

    const dispatch = useAuthDispatcher()

    const {loginState} = useAuthState()

    const token = readToken()
    const navigate = useNavigate()

    const {state} = useLocation()

    const {username, login} = state

    const [verificationCode, setVerificationCode] = useState("");


    useEffect(() => {
        if (typeof token !== "undefined" && token !== null) {
            navigate(RouteInfo.Root.url)
        }
    }, [token])


    function handleDoLogin() {
        if (login) {
            loading.show()
            service.loginUser(username, verificationCode)
                .then(response => {
                    setUserRefreshToken(response.data.refresh_token)

                    dispatch(setLoginStateDispatch(
                        actionTypes.LOGIN,
                        response.data.access_token))

                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت اطلاعات از سرور"))
                loading.hide()
            })
        }
    }

    return (
        <Grid xs={12} id="login-container">
            <section className="loginCardContainer default-card-container-background-style">
                <div className="loginCardBody">
                    <AppBrand/>

                    <span className={css`
                      font-size: 16px;
                      margin-bottom: .5rem;
                      width: 100%;
                      text-align: center;
                      color: var(--color-text);
                      transition: var(--base-transition);
                    `}>
                        پنل مدیریت رایکو
                    </span>
                    <span className={css`
                      font-size: 14px;
                      margin-bottom: 1.5rem;
                      width: 100%;
                      text-align: center;
                      color: var(--color-text);
                      transition: var(--base-transition);
                    `}>
                            لطفا کد تایید ارسال شده را وارد نمایید.
                        </span>

                    <InputSubmitCodeRaiko
                        value={verificationCode}
                        getCodeValue={value => {
                            setVerificationCode(value)
                        }}
                        labelText="کد تایید"/>

                    <ButtonPrimaryRaiko
                        label="بررسی کد تایید"
                        className={css`
                          width: 100%;
                          margin-bottom: 1rem;
                        `}

                        onClick={handleDoLogin}
                    />
                    <NavLink
                        className={css`
                          font-size: var(--text-size-min);
                          margin-top: 1rem;
                          margin-bottom: 1.5rem;
                          color: var(--color-variant);
                          transition: var(--base-transition);

                          &:hover {
                            color: var(--color-text) !important;
                          }
                        `}
                        to={login ? RouteInfo.Login.globalUrl : RouteInfo.ForgetPassword.globalUrl}
                    >
                        ویرایش اطلاعات ورود
                    </NavLink>

                    <CopyRightLinkRaiko/>
                </div>

            </section>

            <div className={css`display: flex;
              align-items: start;
              margin-top: 1rem;
            `}>
                <DarkModeToggle/>
            </div>

        </Grid>
    )
}
export default ConfirmPhoneNumber;